import { isPlainObject } from 'lodash-es';

/**
 * Merge supplied React `ref` objects such that they can be passed to a
 * component's `ref` property and all be assigned the component's DOM Element
 *
 * @example
 * <div> ref={mergeRefs(ref1, ref2)} </div>
 *
 * @param {[{current: Element}, Function]} refs Array that captures all
 * parameters passed to this function.  Items should be either a `ref` object
 * or a function that handles a ref assignment
 * @return {function}
 */
export const mergeRefs =
  (...refs) =>
  el => {
    refs.forEach(ref => {
      if (isPlainObject(ref)) {
        ref.current = el;
      } else if (ref instanceof Function) {
        ref(el);
      }
    });
  };

export default mergeRefs;
